import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { deleteProject } from '@/features/projects/shared/api/delete-project';

export const useDeleteProjectMutation = (
  props: UseMutationOptions<void, unknown, { id: number }> = {},
) => {
  return useMutation({
    ...props,
    mutationFn: async ({ id }) => {
      await deleteProject({ id });
    },
  });
};
